import { graphql } from '../graphql';

export const dashboardStatsQuery = graphql(`
  query DashboardStats {
    dashboardStats {
      projects {
        id
        name
        storageUsedBytes
        positionWGS84
        createdAt
        layerCounts {
          type
          count
        }
      }
      layerTypeCounts {
        type
        count
      }
      totalLayers
    }
  }
`);

export const sharedLinkDashboardQuery = graphql(`
  query SharedLinkDashboard {
    sharedLinkDashboard {
      dailyViews {
        date
        count
      }
      topProjectsByLinks {
        projectId
        projectName
        linkCount
      }
      topLinksByViews {
        id
        name
        projectName
        viewCount
      }
      totalLinks
    }
  }
`);
